import { useState } from "react";
import uuid from "uuid";

export const useQueryControls = (propName, defaultControls) => {
  const [values, setValues] = useState(defaultControls || {});

  const handleUpdate = (id, params) => {
    setValues((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        ...params,
      },
    }));
  };

  const handleAdd = (params) => {
    const id = String(uuid.v4());
    params.uuid = id;
    setValues((prev) => ({
      ...prev,
      [id]: params,
    }));
  };

  const handleAddOrUpdate = (params) => {
    if (params.uuid) {
      handleUpdate(params.uuid, params);
    } else {
      handleAdd(params);
    }
  };

  const handleRemove = (id) => {
    setValues((prev) => {
      const newValues = { ...prev };
      delete newValues[id];
      return newValues;
    });
  };

  const handleRestore = (newControls) => {
    setValues(newControls || defaultControls || {});
  };

  return [
    values,
    {
      add: handleAdd,
      addOrUpdate: handleAddOrUpdate,
      remove: handleRemove,
      restore: handleRestore,
      update: handleUpdate,
    },
  ];
};
